export default __webpack_public_path__ + "static/media/2026_April_Bewegung.8410f6eb.webp";